// Process component
import ExperimentIndex from "@/components/processEditor/index.vue";
import ExperimentGate from "@/components/processEditor/GatewayExperiment.vue";
import ExperimentEditor from "@/components/experimentResult/Editor.vue";

// 실험 관련 Path
const ExperimentRoute = {
  path: "/experiment",
  component: ExperimentIndex,
  meta: { requireAuth: true },
  children: [
    {
      path:'/experiment/gate',
      name:'ExperimentGateway',
      component: ExperimentGate
    },
    {
      path:'/experiment/editor',
      name:'ExperimentEditor',
      component: ExperimentEditor
    },
  ]
} ; 

export default ExperimentRoute ;